import { RootState } from "store/store";
import { connect } from "react-redux";
import Partners from "./Partners";
import {
    setErrorResponseMessage,
    setLoaderVisibility,
} from "store/common/initialization/initialization-actions";
import {
    setAddNewPartner,
    setActivePartner,
    setPartners,
} from "store/partners/partners-actions";
import { getPartnerFilterSearchText } from "store/filters/filters-selectors";
import { getPartners } from "store/partners/partners-selectors";
import { fetchPartners } from "store/partners/partners-thunks";

const mapStateToProps = (state: RootState) => {
    return {
        searchText: getPartnerFilterSearchText(state),
        isAddNewPartnerOpened: state.partnersReducer.isAddNewPartnerOpened,
        errorMessage: state.initializationReducer.errorResponseMessage,
        partners: getPartners(state),
    };
};
const PartnersContainer = connect(mapStateToProps, {
    fetchPartners,
    setLoaderVisibility,
    setAddNewPartner,
    setActivePartner,
    setPartners,
    setErrorResponseMessage,
})(Partners);

export default PartnersContainer;
